import { onUnmounted } from "@vue/composition-api";
import { LiveChatBroadcaster } from "@scrile/api-provider/dist/api/LivechatsProvider";
import providers from "@/lib/api";

export default function useUserBroadcastingUpdated(userId: string, onData: (data: LiveChatBroadcaster) => void) {
  let unsubscribe: () => void = () => {};

  providers.LivechatsProvider.subscribeUserBroadcasterUpdated(userId, onData).then(observer => {
    unsubscribe = () => observer.unsubscribe();
  });

  onUnmounted(() => unsubscribe());
}
